import { Pipe, PipeTransform } from '@angular/core';
import { DataObject } from '@shared/models/data-object.model';
/**
 * Merges given value with next value
 */
@Pipe({
  name: 'combineWith',
  standalone: false,
})
export class CombineWithPipe implements PipeTransform {
  transform(value: DataObject, next: DataObject): DataObject {
    return { ...value, ...next };
  }
}
